/**
 * Copyright IBM Corp. 2022, 2026
 */

// TODO: consider adding this to Tabs
'use client'

import { ReactNode, Suspense } from 'react'
import { Tabs } from '@hashicorp/mds-react/components'
import s from './style.module.css'

interface ITabsWithSkeleton {
	panels: {
		name: string
	}[]
	children: ReactNode
}

export const TabsWithSkeleton = ({ panels, children }: ITabsWithSkeleton) => {
	return (
		<Suspense fallback={<div className={s.skeleton} />}>
			<Tabs.Provider size="large">
				<Tabs.TabList>
					{panels.map((panel, id) => {
						if ('name' in panel) {
							return <Tabs.Tab key={id}>{panel.name}</Tabs.Tab>
						}
					})}
				</Tabs.TabList>
				{children}
			</Tabs.Provider>
		</Suspense>
	)
}
